export default function openNewTab(link) {
  window.open(link, '_blank')
}
